import { DiscordAuthButton } from '@playcastdotio/OAuthButtons';

export const Dev = () => {
  return (
    <div>
      <h1>Dev</h1>
      <DiscordAuthButton />;
    </div>
  );
};
